const packageService = {
  createPackage: {
    url: "/create-package",
    method: "POST",
  },
  checkoutPackage: {
    url: "/package/checkout",
    method: "POST",
  },
};
export default packageService;
